import React from "react";
import round from "lodash/round";
import Slider from "rc-slider/lib/Slider";
import FormattedPrice from "components/elements/formatted-price";

const MIN_PRICE = 10000;
const MAX_PRICE = 3000000;
const PRICE_STEPS = {};
for (let i = MIN_PRICE; i <= MAX_PRICE; i += 1000) {
  if (i < 1000000 && i % 10000 === 0) {
    PRICE_STEPS[i] = i.toString();
  }
  if (i >= 1000000 && i % 100000 === 0) {
    PRICE_STEPS[i] = i.toString();
  }
}
const MIN_FEE = 0.5;
const MAX_FEE = 4;
const FEE_STEPS = {};
for (let j = MIN_FEE; j <= MAX_FEE; j += 0.05) {
  FEE_STEPS[round(j, 2)] = j.toFixed(2);
}

export default class FeeCalculator extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fee: 1.5,
      price: 200000,
    };
  }

  render() {
    const { price, fee } = this.state;
    return (
      <div className="fee-calculator">
        <div className="container">
          <h3 className="section-heading">
            How much could you save with Hammer Price Homes?
          </h3>
          <div className="fee-calculator__sliders row">
            <div className="col-xs-12 col-sm-6">
              <div className="fee-calculator__slider-heading">
                <span className="label">Set your selling price</span>
                <span className="value text-orange">
                  <FormattedPrice price={price} />
                </span>
              </div>
              <div className="fee-calculator__slider">
                <Slider
                  className="theme-orange"
                  onChange={(newPrice) => this.setState({ price: newPrice })}
                  min={MIN_PRICE}
                  max={MAX_PRICE}
                  marks={PRICE_STEPS}
                  step={null}
                  value={price}
                />
              </div>
            </div>
            <div className="col-xs-12 col-sm-6">
              <div className="fee-calculator__slider-heading">
                <span className="label">
                  Set typical estate agent's commission
                </span>
                <span className="value text-blue">{fee.toFixed(2)}%</span>
              </div>
              <div className="fee-calculator__slider">
                <Slider
                  className="theme-blue"
                  onChange={(newFee) => this.setState({ fee: newFee })}
                  min={MIN_FEE}
                  max={MAX_FEE}
                  marks={FEE_STEPS}
                  step={null}
                  value={fee}
                />
              </div>
            </div>
          </div>
          <div className="fee-calculator__summary">
            <div className="summary-item">
              <span className="label">Our fee</span>
              <span className="value">
                <FormattedPrice price={0} />
                <span className="text-orange">*</span>
              </span>
            </div>
            <div className="summary-item">
              <span className="label">Your total saving:</span>
              <span className="value green">
                <FormattedPrice price={price * (fee / 100)} />
              </span>
            </div>
          </div>
          <div className="fee-calculator__footer text-center">
            <span className="text-orange">*</span> It is completely free to sell
            your property with Hammer Price Homes!
          </div>
        </div>
      </div>
    );
  }
}
